export const scrollToElementWithOffset = (element, offset = 80) => {
  if (!element || typeof window === 'undefined') {
    return;
  }

  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: 'smooth' });
};

export const scrollToElementByIdWithOffset = (elementId, offset = 80) => {
  if (typeof document === 'undefined') {
    return;
  }

  const element = document.getElementById(elementId);
  scrollToElementWithOffset(element, offset);
};